import axios from 'axios';
import Config from '../../config/Config.js'

export const FETCH_USER = (username) => {
    return axios
        .get(
            `${Config().userUrl}?username=${username}`
        )
        .then(res => {
            const data = res.data;
            return Array.isArray(data) ? data[0] : data.results?.[0]
        })
        .catch(err => {
            console.error('FETCH_USER Error:', err);
            console.error('FETCH_USER Error Response:', err.response);
            console.error('FETCH_USER Error Status:', err.response?.status);
            console.error('FETCH_USER Error Data:', err.response?.data);
            throw err; // Re-throw so ProfilePage can handle the UI error state
        });
};

export const FETCH_EXTENDED_USER = (id) => {
    return axios
        .get(
            `${Config().extendedUserUrl}${id}`
        )
        .then(res => {
            return res.data
        })
        .catch(err => {
            console.error('FETCH_EXTENDED_USER Error:', err);
            console.error('FETCH_EXTENDED_USER Error Response:', err.response);
            console.error('FETCH_EXTENDED_USER Error Status:', err.response?.status);
            console.error('FETCH_EXTENDED_USER Error Data:', err.response?.data);
            throw err; // Re-throw so ProfilePage can handle the UI error state
        });
}

export const FETCH_PROJECTS = (id, publish) => {
    return axios
        .get(`${Config().baseUrl}?owner=${id}&publish=${publish}`)
        .then(res => {
            const data = res.data;
            return Array.isArray(data) ? data : data.results || []
        })
        .catch(err => {
            console.error('FETCH_PROJECTS Error:', err);
            console.error('FETCH_PROJECTS Error Response:', err.response);
            console.error('FETCH_PROJECTS Error Status:', err.response?.status);
            console.error('FETCH_PROJECTS Error Data:', err.response?.data);
            throw err; // Re-throw so ProfilePage can handle the UI error state
        });
}